import { useState } from 'react';

const useClipboard = () => {
  const [copySuccess, setCopySuccess] = useState('');

  const copyToClipboard = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopySuccess('success');

      setTimeout(() => {
        setCopySuccess('');
      }, 2000);
    } catch (err) {
      console.error('Failed to copy: ', err);
      setCopySuccess('Failed to copy!');

      setTimeout(() => {
        setCopySuccess('');
      }, 2000);
    }
  };

  return { copySuccess, copyToClipboard };
};

export default useClipboard;